import React, {useEffect, useState, useCallback} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import debounce from 'lodash.debounce';
import {getElevators, getEntrances, getPdfReports} from '../actions';
import {Filters, Layout, PageHeader} from '../components';
import {Box, Pagination} from '@mui/material';
import useFilters from '../utils/useFilters';
import ElevatorsTable from '../components/CustomTables/ElevatorsTable';

const Elevators = () => {
  const dispatch = useDispatch();
  const {elevators, elevatorsLoading, elevatorsPage, elevatorsTotalPages} =
    useSelector(s => s.elevators);
  const filters = useFilters(val => dispatch(getElevators(val)));
  const {user} = useSelector(s => s.user);

  const onPageChange = (e, value) => {
    dispatch(getElevators({page: value, ...filters.filters}));
  };

  useEffect(() => {
    dispatch(getElevators());
    // dispatch(getPdfReports({templateType: 'ESCALATOR'}));
  }, []);

  return (
    <Layout>
      <PageHeader title="Elevators" />
      {!!user?.role && user?.role !== 'ELEVATOR_SUPERVISOR' ? (
        <Filters m="1.5rem" withSearch withBuilding {...filters} />
      ) : (
        <Filters
          m="1.5rem"
          withSearch
          withBuilding={false}
          {...filters}
        />
      )}
      <ElevatorsTable
        elevators={elevators}
        loading={elevatorsLoading}
        hideAddButton
      />
      {elevatorsTotalPages > 1 && (
        <Box mt="1rem" display="flex" justifyContent="center">
          <Pagination
            count={elevatorsTotalPages}
            page={elevatorsPage}
            onChange={onPageChange}
          />
        </Box>
      )}
    </Layout>
  );
};

export default Elevators;
